const PlanFunctionsForFlag = {
    Depot: "Depot",
    DeleteDepot: "Delete Depot",
    HookOff: "Hook Off",
    DeleteHookOff: "Delete Hook Off",
    CustomHookOff: "Custom Hook Off",
    InsertTerminals: "Insert Terminals",
    DeleteTerminal: "Delete Terminal",
    PlanMovementsNewNotification: "Plan Movements New Notification",
    PlanMovementsNewConfirmation: "Plan Movements New Confirmation",
    CreateTrip: "Create Trip",
    Postpone: "Postpone",
    ChangePlanDepartment: "Change Plan Department",
    ChangePlanSubdepartment: "Change Plan Subdepartment",
    OnHold: "On Hold",
    RegroupTrip: "Regroup Trip",
    NewpartialTrip: "New partial Trip",
    ChangePTResourceConfirmation: "Change PT Resource Confirmation",
    CalculateConfirmation: "Calculate Including Action Times Confirmation",
    CalculateNotification: "Calculate Including Action Times Notification",
    WarningsMoveUp: "Warnings - MoveUp",
    WarningsMoveDown: "Warnings - MoveDown",
    SetFree: "Set Free",
    SetFreeRoutes: "Set Free Routes",
    InsertExtraAction : "Insert Extra Action",
    Remark: "Remark",
    AgendaItem: "Agenda Item",
    MoveAgendaItem: "Move Agenda Item",
    Fixed:"Fixed",
    ContractOut: 'Contract Out',
    SendMessageToOBC : "Send Message to OBC",
    DeletePartialTrip : 'Delete Partial Trip',
    RemoveFromCurrentResource : 'Remove From Current Resource',
    RemoveFromAllResources : 'Remove From All Resources',
    DeleteSelection : 'Delete Selection',
    SendToBack : 'Send To Back',
    ShowDetailsActionItemRemark : 'Show Details Action Item/ Remark',
    ChangeSequence : 'Change Sequence',
    ConfirmNewPartialTrip : 'Confirm New Partial Trip',
    PlanMovementsOnAgenda: 'PlanMovements On Agenda',
    PlanPartialTripOnAgenda: 'Plan PartialTrip On Agenda',
    MoveMovement : "Move Movement",
    BatchTripCreation:"Batch Trip Creation",
    TruckAppointmentOverview:"Truck Appointment Overview",
    TruckAppointmentNew:"Truck Appointment New",
    TruckAppointmentAddTo:"Truck Appointment Add To",
    Refresh : 'Refresh',
    PlanOnMap:"Plan On Map"
}

export { PlanFunctionsForFlag };